<template>
  <div :class="{body:show}">
    <el-dialog
        :visible="show"
        title="修改密码"
        width="800px"
        append-to-body
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :before-close="close"
        @open="init"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="100px">
        <el-form-item label="原密码" prop="old_password">
          <el-input v-model="form.old_password" type="password" clearable maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="新密码" prop="password">
          <el-input v-model="form.password" type="password" clearable maxlength="50"></el-input>
        </el-form-item>
        <el-form-item label="密码确认" prop="confirm_password">
          <el-input v-model="form.confirm_password" type="password" clearable maxlength="50"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">关闭</el-button>
        <el-button type="primary" :loading="loading" @click="save">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as selfApi from '@/api/self'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    let validateConfirmPassword = (rule, value, callback) => {
      if (value !== this.form.password) {
        callback(new Error('两次输入密码不一致'))
      } else if (value.indexOf(' ') !== -1 || value.indexOf('　') !== -1) {
        callback(new Error('新密码不能由空格组成'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      form: {
        old_password: '',
        password: '',
        confirm_password: ''
      },
      rules: {
        old_password: [
          {required: true, validator: this.$validator.checkNotBlank, message: '请输入旧密码', trigger: 'blur'}
        ],
        password: [
          {required: true, validator: this.$validator.checkNotBlank, message: '请输入新密码', trigger: 'blur'}
        ],
        confirm_password: [
          {required: true, validator: this.$validator.checkNotBlank, message: '请确认新密码', trigger: 'blur'},
          {validator: validateConfirmPassword, trigger: 'blur'}
        ]
      }
    }
  },
  methods: {
    init() {
    },
    save() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true
          let param = {
            old_password: this.form.old_password,
            password: this.form.password
          }
          selfApi.updatePassword(param).then(rr => {
            this.loading = false
            this.$base.success(this, rr, this.close)
          }).catch(rr => {
            this.loading = false
            this.$base.failure(this, rr)
          })
        }
      })
    },
    close(t) {
      this.$refs.form.resetFields()
      this.$emit('close', !t || t.type === 'success')
    }
  }
}
</script>
